var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#FDF1EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.39 22.3188L19.5 22.3096C20.6 22.3096 21.5 21.4096 21.5 20.3096V12.5996C21.5 11.4996 20.6 10.5996 19.5 10.5996L8.5 10.6069C7.4 10.6069 6.5 11.5069 6.5 12.6069V20.3169C6.5 21.4169 7.4 22.3169 8.5 22.3169L10.27 22.3188C10.54 22.3188 10.8 22.4288 10.99 22.6188L13.17 24.8688C13.52 25.2288 14.09 25.2288 14.44 24.8688L16.68 22.6088C16.87 22.4188 17.12 22.3088 17.39 22.3088V22.3188Z",
    stroke: "#EC5F2A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10.7987V9.38567C11 8.4549 11.798 7.69336 12.7733 7.69336H23C23.9753 7.69336 24.7733 8.4549 24.7733 9.38567V17.0011C24.7733 17.9318 23.9753 18.6934 23 18.6934H21.9234",
    stroke: "#EC5F2A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18C11.5523 18 12 17.5523 12 17C12 16.4477 11.5523 16 11 16C10.4477 16 10 16.4477 10 17C10 17.5523 10.4477 18 11 18Z",
    fill: "#EC5F2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18C14.5523 18 15 17.5523 15 17C15 16.4477 14.5523 16 14 16C13.4477 16 13 16.4477 13 17C13 17.5523 13.4477 18 14 18Z",
    fill: "#EC5F2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18C17.5523 18 18 17.5523 18 17C18 16.4477 17.5523 16 17 16C16.4477 16 16 16.4477 16 17C16 17.5523 16.4477 18 17 18Z",
    fill: "#EC5F2A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.400c6bc1ea6d5a949eb4a7b245476609.svg";
export { ForwardRef as ReactComponent };